"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createStorybookConfig_exports = {};
__export(createStorybookConfig_exports, {
  default: () => createStorybookConfig
});
module.exports = __toCommonJS(createStorybookConfig_exports);
var import_constants = require("../constants");
function createStorybookConfig(options) {
  const { title, storybookTheme } = options;
  return {
    addons: [
      "storybook-addon-themes",
      "@webplatform/storybook-addon-section-json"
    ],
    parameters: {
      sectionJson: true,
      themes: {
        default: title,
        list: [
          {
            name: title,
            class: [`${import_constants.ASBIS_UI_THEME_PREFIX}-${storybookTheme}`],
            color: "#000000"
          }
        ]
      },
      layout: "fullscreen",
      options: {
        storySort: {
          order: ["Sections", "AsbisUI", "AppComponents", "UiComponents"]
        }
      }
    },
    webpackFinal: async (config) => {
      config.resolve.symlinks = false;
      return config;
    },
    stories: [
      "~/domains/**/*.stories.js",
      "~/node_modules/@webplatform/asbis-ui/**/*.stories.js"
    ]
  };
}
